__webpack_require__.p = "https://store.zigzag.kr/resources/arm64/20260305-1549-72d6b8f382_store/_next/";